import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { WidgetFrame, ProgressWidget, ErrataWidget }
  from "../../../personal-studio-components/studio";
import { StudentService }
  from "../../components/studentService";
//from "../../Config.js";
export { StudentStudyCard };
/** 
 * Страница Профиль / Учебная карточка обучающегося
 */
function StudentStudyCard({ }) {
  const title = "Учебная карточка обучающегося";
  const { contractId } = useSelector((state) => state.contract);
  const { access_token } = useSelector((state) => state.token);
  const [response, setResponse] = useState(null);
  const request =
  {
    method: "post",
    path: "/student/study_card",
    data:
    {
      access_token,
      study_contract_id: contractId,
    }
  };
  useEffect(() => { StudentService.send(request, setResponse); },
    [access_token, contractId]);
  if (!response)
    return <ProgressWidget title={title} />;
  if (response.errors)
    return <ErrataWidget errata={response} />;
  const href = response.href;
  window.open(href, "_blank");
  history.back();
  return <ProgressWidget title={title} />;
}
